var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "for rent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_31_home_rent",
    "data-name": "31 home rent"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    d: "M184,358.31H189l8.45,14.74h14.88l-10.14-17.65a15.92,15.92,0,0,0,5.07-5.92,17.09,17.09,0,0,0,1.83-7.81,16,16,0,0,0-1.22-6.05,17.7,17.7,0,0,0-3.35-5.34,16.89,16.89,0,0,0-5.11-3.79A14.6,14.6,0,0,0,192.9,325h-22v48H184Zm0-21.78h8a3.41,3.41,0,0,1,2.43,1.32,5.44,5.44,0,0,1,1.22,3.82,6.06,6.06,0,0,1-1,3.79,2.92,2.92,0,0,1-2.27,1.35H184Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_",
    "data-name": "<Path>",
    points: "250.73 361.56 229.69 361.56 229.69 353.99 247.14 353.99 247.14 343.3 229.69 343.3 229.69 336.54 250.12 336.54 250.12 325.04 216.5 325.04 216.5 373.06 250.73 373.06 250.73 361.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_2",
    "data-name": "<Path>",
    points: "270.07 349.45 289.14 373.06 299.62 373.06 299.62 325.04 286.43 325.04 286.43 349.45 267.16 325.04 256.88 325.04 256.88 373.06 270.07 373.06 270.07 349.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_Path_3",
    "data-name": "<Path>",
    points: "318.29 373.06 331.47 373.06 331.47 336.54 345.27 336.54 345.27 325.04 304.42 325.04 304.42 336.54 318.29 336.54 318.29 373.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_2",
    "data-name": "<Compound Path>",
    d: "M421.53,266.87l28.39,21.84,47.64-52.15L415,173V49.14H332.54v60.48L256,50.73,14.44,236.56l47.64,52.15,28.39-21.84v176H15v20H497v-20H421.53Zm-69-197.73H395v88.52L352.54,125Zm-308.65,170L256,76,468.11,239.14l-20.56,22.51L256,114.3,64.45,261.65Zm66.58,203.72V251.52L256,139.57,401.53,251.52V442.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_3",
    "data-name": "<Compound Path>",
    d: "M256,216.41l-88.17,73H139V408.06H373V289.39H344.16Zm0,26,56.8,47H199.2Zm97,145.69H159V309.39H353Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ab5c7ecbd4d7b117dc10c66ea0152c54.svg";
export { ForwardRef as ReactComponent };